import { createSlice } from '@reduxjs/toolkit';

export const subLessonModalSlice = createSlice({
  name: 'subLessonModal',
  initialState: {
    showModal: false,
    lessonData: null,
  },
  reducers: {
    setSubLessonModal: (state, action) => {
      state.showModal = action.payload.showModal;
      state.lessonData = action.payload.lessonData;
    },
  },
});

export const { setSubLessonModal } = subLessonModalSlice.actions;
export default subLessonModalSlice.reducer;
